import React from 'react';

import cl from './Contacts.module.css'

import contactImg from '../../../assets/images/main_contact_img.png'
import Footer from '../../../components/Footer/Footer';
import ContactForm from '../../../components/ContactForm/ContactForm';

const Contacts = () => {
    return (
        <div className='contacts_page'>
            <div className={cl.contact_main_container}>
                <div className={cl.left_side_contact}>
                    <h2 className={cl.title_contact}>
                        We’re Here to Help
                    </h2>
                    <p className={cl.contact_description}>
                        Have questions or need assistance? Reach out via phone, email, or live chat. Our dedicated support team is ready to assist you.
                    </p>
                    <h3 className={cl.subtitle_contact}>
                        Contact Details:
                    </h3>
                    <div className={cl.contact_info_row}>
                        <span className={cl.contact_info_item}>
                            Email: info@fortres.tech
                        </span>
                        <span className={cl.contact_info_item}>
                            Phone: +420775497164
                        </span>
                        <span className={cl.contact_info_item}>
                            Live Chat: Available 9 AM - 6 PM (Singapore Time)
                        </span>
                        <span className={cl.contact_info_item}>
                            Office Address: Olštýnská 607/1, Troja (Praha 8), 181 00 Praha<br/>
                            P.O. Box 149, PC 325, Sultanate of Oman
                        </span>
                    </div>
                </div>
                <div className={cl.right_side_contact}>
                    <img src={contactImg} alt="#contact_img" />
                </div>
            </div>
            <ContactForm />
          
        </div>
    );
};

export default Contacts;